export default "<span *ngIf=\"showFirstName\">\n  {{ profile?.FirstName }}\n</span>\n<span *ngIf=\"showLastName\">\n  {{ profile?.LastName }}\n</span>\n"